import { SignIn as ClerkSignIn } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';

export function SignIn() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 px-4">
      {/* Header */}
      <header className="py-4">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm">
          ← Back to Home
        </Link>
      </header>

      <div className="flex-grow flex items-center justify-center">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg shadow-green-500/25">
                <span className="text-white text-2xl">✓</span>
              </div>
              <div className="text-left">
                <h1 className="text-2xl font-bold text-white">DemoPath</h1>
                <p className="text-sm text-slate-400">by Apparently</p>
              </div>
            </div>
            <p className="text-slate-300">Sign in to track your demo talking points</p>
          </div>

          <ClerkSignIn
            appearance={{
              elements: {
                rootBox: 'w-full',
                card: 'shadow-xl rounded-xl border border-slate-700 bg-slate-800',
                headerTitle: 'text-white',
                headerSubtitle: 'text-slate-400',
                socialButtonsBlockButton: 'border-slate-600 bg-slate-700 hover:bg-slate-600 text-white',
                socialButtonsBlockButtonText: 'text-white',
                formFieldLabel: 'text-slate-300',
                formFieldInput: 'bg-slate-700 border-slate-600 text-white focus:ring-green-500 focus:border-green-500',
                formButtonPrimary: 'bg-green-500 hover:bg-green-600',
                footerActionLink: 'text-green-400 hover:text-green-300',
                footerActionText: 'text-slate-400',
                identityPreviewText: 'text-white',
                identityPreviewEditButton: 'text-green-400',
                formFieldInputShowPasswordButton: 'text-slate-400',
                dividerLine: 'bg-slate-600',
                dividerText: 'text-slate-400',
              },
            }}
            routing="path"
            path="/sign-in"
            signUpUrl="/sign-up"
            forceRedirectUrl="/app"
            fallbackRedirectUrl="/app"
          />
        </div>
      </div>
    </div>
  );
}
